<template>
  <b-col md="3" sm="3" xl="3" class="text-center animated fadeIn fadeOut">
    <!-- block 을 안했을 경우 요청에 대한 결과가 응답으로 노출되므로 더 위험, 그러므로 danger 로 표시 -->
    <b-card :bg-variant="has_online ? (wc.is_row == false ? 'success' : wc.is_block ? 'warning' : 'danger') : 'gray'" @click="detail(wc)" :style="{ cursor: 'pointer'}">
      <!-- <h6><strong>{{item.name || '-'}}</strong></h6> -->
      <!-- <h6>{{item.host}}@{{item.ip_addr}}<br></h6> -->
      <!-- <b-badge variant="success" v-if="!item.ms == 0 ">Online ({{item.ms}} ms)</b-badge> -->
      <b-badge variant="light" style="min-width: 100px; max-width: 130px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">{{wc.name}}</b-badge>
    </b-card>
  </b-col>
</template>

<script>
export default {
  computed: {
    has_online() { return (this.wc_pong_list || []).indexOf(this.wc.agent_id) > -1 }
  },
  props: ['wc', 'wc_pong_list'],
  methods: { detail: function(wc) {

    try {
      let version = Number(wc.version.replace(/v/, '').replace(/(\.)/gm, '').substring(0, 6));

      // console.log(wc.agent_id)

      if(version < 202207) {

        this.$router.push({ name : 'webcastle_modules', params : {  version : 'v1', id : wc.agent_id } });
        return
      }

      this.$router.push({ name : 'webcastle_agent', params : { id : wc.agent_id } });
      return

    } catch (e) {

      console.error(e)
      this.$router.push({ name : 'webcastle_modules', params : {  version : 'v1', id : wc.agent_id } });

    }
  }
    // this.$router.push({ name : 'webcastle_modules', params : { version : 'v2', id : wc.agent_id } }); },
  },
  created () { console.info('agent-item.vue created') },
  destroyed () { console.log('webcastle-agent-item.vue destroyed') },
  mounted () {  console.log('webcastle-agent-item.vue mounted'); setTimeout(this.$forceUpdate(), 1000); },
}
</script>
